var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9834 7.08342C15.3501 -0.13325 4.65842 -0.141584 3.01675 7.07508C2.05842 11.3084 4.69175 14.9001 6.99175 17.1167C8.67508 18.7334 11.3251 18.7334 13.0001 17.1167C15.3084 14.9001 17.9418 11.3167 16.9834 7.08342ZM8.15039 8.5917C8.15039 7.56997 8.97866 6.7417 10.0004 6.7417C11.0221 6.7417 11.8504 7.56997 11.8504 8.5917C11.8504 9.61343 11.0221 10.4417 10.0004 10.4417C8.97866 10.4417 8.15039 9.61343 8.15039 8.5917ZM10.0004 5.2417C8.15024 5.2417 6.65039 6.74155 6.65039 8.5917C6.65039 10.4419 8.15024 11.9417 10.0004 11.9417C11.8505 11.9417 13.3504 10.4419 13.3504 8.5917C13.3504 6.74155 11.8505 5.2417 10.0004 5.2417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAreaIcon);
export default __webpack_public_path__ + "static/media/service-area-icon.7d0486d8669435bb0280357807c0f95d.svg";
export { ForwardRef as ReactComponent };